// extracted by mini-css-extract-plugin
export default {"popup":"NoIGLinkPopup_popup__RWyM3","popupInner":"NoIGLinkPopup_popupInner__rJd3m","closeButton":"NoIGLinkPopup_closeButton__1cwQU"};